exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_MediaSelectorLinkContainer_2ajGtbUy6WT2v9vGPAZ-B{\n  display: flex;\n  flex-direction: row;\n  width: calc(100% - 10px);\n  align-items: end;\n}", ""]);

// Exports
exports.locals = {
	"IA_MediaSelectorLinkContainer": "IA_MediaSelectorLinkContainer_2ajGtbUy6WT2v9vGPAZ-B"
};